export const LIST_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_MS = 300;
